'use client';

import { Box, Flex, Text } from '@shared/ui';
import i18n from '@shared/i18n';
import { convertDate } from 'app/libs/convertDate';
import { Picture } from 'app/components/Picture';
import { useRouter } from 'next/navigation';

interface OrderCardProps {
    order: Order;
}

export const OrderCard: React.FC<OrderCardProps> = ({ order }) => {
    const router = useRouter();

    return (
        <Flex
            flexDirection="column"
            w="100%"
            bg="neutral.000"
            _hover={{
                bg: 'dynamic.010',
            }}
            p="s"
            borderRadius="lg"
            gap="xs"
            cursor="pointer"
            onClick={() => {
                router.push(`/order/${order.id}`);
            }}
        >
            <Flex w="100%" justifyContent="space-between">
                <Text color="neutral.080">{convertDate(order.create_datetime)}</Text>
                <Text color="neutral.080">
                    {i18n.gettext('訂單編號：')}
                    {order.serial_number}
                </Text>
            </Flex>
            <Flex w="100%" gap="xs">
                <Box w="60px" h="60px">
                    <Picture
                        src={order.image?.src}
                        width={100}
                        height={100}
                        alt={order.serial_number}
                    />
                </Box>
                <Flex flexDirection="column" flex="1" justifyContent="space-between">
                    <Text fontWeight="bold" fontSize="16px">
                        {order.preview_name}
                    </Text>
                    <Flex justifyContent="space-between">
                        <Text color="neutral.090">
                            {i18n
                                .gettext('{count} 件商品')
                                .replace('{count}', order.product_count.toString())}
                        </Text>
                        <Text fontWeight="bold" color="primary.050">
                            {order.grand_total_price?.value}
                        </Text>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};
